import React from 'react'

interface RenderIfProps {
  isShow?: boolean
  children: React.ReactNode
}

const RenderIf: React.FC<RenderIfProps> = ({ isShow = true, children }) => {
  return isShow ? <>{children}</> : null
}

export default RenderIf
